"use client";

import { NotFoundContent } from "@/common/components/organisms/not-found-content";

export default function LangNotFound() {
  return <NotFoundContent />;
}
